import { NgModule } from '@angular/core';
import { AutoCompleteComponent } from './auto-complete.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AutoCompleteComponent],
  imports: [CommonModule, AutoCompleteModule, FormsModule],
  exports: [AutoCompleteModule, AutoCompleteComponent],
})
export class AutoCompleteComponentModule {}
